import { FC } from 'react';

import classNames from 'classnames';

import { Menu } from '../../Menu';
import { TestMetadata } from '../../types';
import { useResponsiveNavBar } from '../NavBarContext';

import './NavBarMenu.scss';

export interface NavBarMenuProps {
  /** Custom class to pass to menu */
  className?: string;
  /** TestMetadata for menu */
  testMetadata?: TestMetadata;
}

const NavBarMenu: FC<NavBarMenuProps> = ({
  className,
  testMetadata,
  children,
  ...otherProps
}) => {
  const { getBreakpointClassName } = useResponsiveNavBar();

  return (
    <Menu
      {...otherProps}
      className={classNames(
        getBreakpointClassName('sb-navbar-menu'),
        className,
      )}
      {...testMetadata}
    >
      {children}
    </Menu>
  );
};

export default NavBarMenu;
